import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SectionHeading } from "@/components/SectionHeading";
import { RevealGroup, RevealItem, Reveal } from "@/components/Reveal";
import { showcase } from "@/data/content";

export default function Showcase() {
  return (
    <section className="bg-white py-24 lg:py-32" data-testid="showcase-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHeading
          eyebrow="Our Work"
          title="Selected Hospitality Projects"
          subtitle="Real hospitality properties supported through the HM Services platform."
        />

        <RevealGroup className="mt-16 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {showcase.map((p) => (
            <RevealItem key={p.name}>
              <Link
                to={`/portfolio/${p.slug}`}
                className="group block h-full"
              >
                <article
                  data-testid={`showcase-card-${p.name
                    .toLowerCase()
                    .replace(/\s+/g, "-")}`}
                  className="flex h-full flex-col overflow-hidden rounded-2xl border border-line bg-white shadow-float transition-[transform,box-shadow] duration-300 hover:-translate-y-2 hover:shadow-float-lg"
                >
                  <div className="relative h-52 overflow-hidden">
                    <img
                      src={p.image}
                      alt={`${p.type} in ${p.city}`}
                      className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                      loading="lazy"
                    />

                    <span className="absolute left-4 top-4 rounded-full bg-white/90 px-3 py-1 text-xs font-semibold text-navy backdrop-blur">
                      {p.type}
                    </span>
                  </div>

                  <div className="flex flex-1 flex-col p-6">
                    <h3 className="font-serif text-xl font-semibold text-navy">
                      {p.name}
                    </h3>

                    <p className="mt-1.5 flex items-center gap-1.5 text-sm text-slate-500">
                      <MapPin className="h-3.5 w-3.5 text-ocean" />
                      {p.city}
                    </p>

                    <p className="mt-3 flex-1 text-sm leading-relaxed text-slate-600">
                      {p.desc}
                    </p>

                    <p className="mt-4 border-t border-line pt-4 text-xs font-medium text-ocean">
                      {p.services}
                    </p>

                    <p className="mt-4 text-sm font-semibold text-navy">
                      View Project →
                    </p>
                  </div>
                </article>
              </Link>
            </RevealItem>
          ))}
        </RevealGroup>

        <Reveal className="mt-14 overflow-hidden rounded-3xl bg-navy px-8 py-12 text-center">
          <p className="font-serif text-2xl font-semibold text-white sm:text-3xl">
            Your Property Could Be Our Next Success Story
          </p>

          <Button
            asChild
            className="mt-6 rounded-full bg-sky px-8 py-6 text-base font-semibold text-navy hover:bg-sky-light"
            data-testid="showcase-work-with-us"
          >
            <Link to="/list-your-property">Work With Us</Link>
          </Button>
        </Reveal>
      </div>
    </section>
  );
}
